<template>
  <div>
    <template v-if="!displayAsPopup">
      <v-autocomplete
        v-model="selectedFilters"
        :items="filteredPayrollFilter"
        chips
        class="mt-2"
        label="Columns"
        item-text="name"
        item-value="slug"
        multiple
      >
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            color="primary"
            @click="data.select"
            @click:close="remove(data.item)"
          >
            {{ data.item.name }}
          </v-chip>
        </template>
      </v-autocomplete>
      <v-alert class="pa-2 mt-0" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
        <span class="caption">{{ serverValidationMessage }}</span>
      </v-alert>
      <v-layout>
        <div @click="resetFilterToDefault" class="body-2 primary--text text-decoration-underline pointer">Reset Default</div>
        <v-spacer></v-spacer>
        <v-btn
          :loading="editPayrollFilterLoading"
          :disabled="editPayrollFilterLoading"
          @click="editPayrollFilter"
          color="primary"
        >Save Filters</v-btn>
      </v-layout>
    </template>
    <template v-else>
      <v-dialog v-if="editPayrollFilterDialog" v-model="editPayrollFilterDialog" max-width="700px" persistent>
          <v-card class="pa-4">
              <v-card-title>
                  <h2 class="title">Show/Hide Payroll Info</h2>
              </v-card-title>
              <div class="px-4 pt-4 pb-2">
                Please hide information that you do not use. Your changes will be applied to all payroll views for all staff.
              </div>
              <div class="pa-4">
                  <v-layout class="wrap payroll-data-select">
                      <v-flex v-for="(item, index) in payrollFilter" class="xs12 md6" :key="index">
                          <v-checkbox
                              class="ma-0"
                              :value="item.slug"
                              v-model="selectedFilters"
                              :label="item.name"
                          ></v-checkbox>
                      </v-flex>
                  </v-layout>
                  <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                      <span class="caption">{{ serverValidationMessage }}</span>
                  </v-alert>
              </div>
              <v-card-actions class="px-4">
                  <span @click="resetFilterToDefault" class="action-link" style="text-decoration: underline;">Reset To Default</span>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeEditPayrollFilter">Cancel</v-btn>
                  <v-btn color="primary" :loading="editPayrollFilterLoading" :disabled="editPayrollFilterLoading" @click="editPayrollFilter">Save
                  </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditPayrollFilter',
  props: {
    displayAsPopup: {
      type: Boolean,
      default: () => true
    },
    headers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      payrollFilter: [
        { 'slug': 'years_in_service', 'name': 'Years in Service', 'show': true, 'defaultShow': true }, 
        { 'slug': 'worked_hours', 'name': 'Worked Hours', 'show': true, 'defaultShow': true },      
        { 'slug': 'residential_revenue', 'name': 'Residential Revenue', 'show': true, 'defaultShow': false },
        { 'slug': 'residential_bonus', 'name': 'Additional Residential Services Revenue', 'show': true, 'defaultShow': false },
        { 'slug': 'commercial_revenue', 'name': 'Commercial Revenue', 'show': true, 'defaultShow': false },
        { 'slug': 'commercial_bonus', 'name': 'Additional Commercial Services Revenue', 'show': true, 'defaultShow': false },
        { 'slug': 'revenue', 'name': 'Revenue', 'show': true, 'defaultShow': true }, 
        { 'slug': 'revenue_adjustment', 'name': 'Revenue Adjustment', 'show': true, 'defaultShow': true }, 
        { 'slug': 'distance', 'name': 'Distance', 'show': true, 'defaultShow': true }, 
        { 'slug': 'regular_hours', 'name': 'Regular Hours', 'show': true, 'defaultShow': true }, 
        { 'slug': 'overtime_hours', 'name': 'Overtime Hours', 'show': true, 'defaultShow': true }, 
        { 'slug': 'holiday', 'name': 'Holiday Hours', 'show': true, 'defaultShow': true }, 
        { 'slug': 'vacation_hours', 'name': 'Vacation Hours', 'show': true, 'defaultShow': true }, 
        { 'slug': 'pto_hours', 'name': 'PTO', 'show': true, 'defaultShow': true }, 
        { 'slug': 'tips', 'name': 'Tips', 'show': true, 'defaultShow': true }, 
        { 'slug': 'addl_bonus', 'name': 'Addl Bonus', 'show': true, 'defaultShow': true }, 
        { 'slug': 'reimbursement', 'name': 'Msc Reimb', 'show': true, 'defaultShow': true }, 
        { 'slug': 'deduction', 'name': 'Deductions', 'show': true, 'defaultShow': true }, 
        { 'slug': 'number_of_jobs', 'name': 'Nr of Jobs', 'show': true, 'defaultShow': true }, 
        { 'slug': 'number_of_complaints', 'name': 'Nr of Complaints', 'show': true, 'defaultShow': true }, 
        { 'slug': 'mileage_rate', 'name': 'Mileage Rate', 'show': true, 'defaultShow': true }, 
        { 'slug': 'hourly_rate', 'name': 'Hourly Rate', 'show': true, 'defaultShow': true }, 
        { 'slug': 'base_percentage', 'name': 'Base Percentage', 'show': true, 'defaultShow': true }, 
        { 'slug': 'yard_rate', 'name': 'Per Yard Rate', 'show': true, 'defaultShow': true }, 
        { 'slug': 'fixed_rate', 'name': 'Fixed Rate', 'show': true, 'defaultShow': true }
      ],
      selectedFilters: [],
      selectedOutOfHeaders: [],
      editPayrollFilterDialog: false,
      loadingOrganizationSettings: false,
      editPayrollFilterLoading: false,
      serverValidation: true,
      serverValidationMessage: "Oops something went wrong...",
      server_errors: {},
      unsubscribe: null
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'EditPayrollFilter') {
          this.openModal(action.payload.data)
      }
    })
    this.getOrganizationSettings();
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['checkOrganizationSettings', 'vEmit']),
    getOrganizationSettings(mandatory = false) {
      this.loadingOrganizationSettings = true;
      return new Promise((resolve, reject) => {
      this.checkOrganizationSettings(mandatory)
        .then(response => {
          if(response.payroll_filter) {
            let filter_value = response.payroll_filter.split(',')
            this.payrollFilter.forEach(i => { i.show = filter_value.includes(i.slug)})
          }
          this.selectedFilters = this.sortByHeaders(this.payrollFilter.filter(i => i.show).map(i => i.slug))
          this.loadingOrganizationSettings = false;
          resolve()
        })
        .catch(({ response }) => {
          this.loadingOrganizationSettings = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(response.data.error);
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              this.serverValidationMessage = response.data.errors;
            } else {
              this.server_errors = response.data.errors;
            }
          }
          reject(response)
        });
      })
    },
    sortByHeaders(array) {
      let output = []
      if(this.headers.length) {
        this.payrollFilter.forEach(i => {
          if(this.headerSlugs.includes(i.slug)) {
            i.name = this.headers.find(h => h.payroll_filter === i.slug).text
          }
        })
        this.headers.forEach(h => {
          if(array.some(i => i === h.payroll_filter) && !output.includes(h.payroll_filter)) {
            output.push(h.payroll_filter)
          }
        })
        this.selectedOutOfHeaders = array.filter(i => !output.includes(i))
        return output
      } else {
        return array
      }
    },
    remove (item) {
      this.selectedFilters = this.selectedFilters.filter(i => i !== item.slug)
    },
    openModal() {
      this.editPayrollFilterDialog = true
      this.selectedOutOfHeaders = []
      this.selectedFilters = this.sortByHeaders(this.payrollFilter.filter(i => i.show).map(i => i.slug))
    },
    editPayrollFilter() {
      let value = [...this.selectedFilters, ...this.selectedOutOfHeaders].join(',')
      let body = {
        organization_settings: [
          {
            key: "payroll_filter",
            value: value
          }
        ]
      };
      if(this.selectedFilters.length === 0) {body.organization_settings[0].value = 'empty'}
      this.editPayrollFilterLoading = true;
      this.resetServerValidation();

      ApiService.put("/organization_settings", body)
        .then(response => {
          this.editPayrollFilterLoading = false;
          this.vEmit({ 
            name: "notification", 
            data: {
              status: "success",
              text: "Payroll data filter has been successfully edited."
            }
          })
          this.closeEditPayrollFilter();
          this.getOrganizationSettings(true)
            .then(() => {
              this.$emit('done');
            })
        })
        .catch(({ response }) => {
          this.editPayrollFilterLoading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(response.data.error);
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              this.serverValidationMessage = response.data.errors;
            } else {
              this.server_errors = response.data.errors;
            }
          }
        });
    },
    closeEditPayrollFilter() {
      this.editPayrollFilterDialog = false
    },
    resetFilterToDefault () {
      let output = []
      if(this.headers.length) {
        let sortedOutput = []
        this.payrollFilter.forEach(i => {
          if(i.defaultShow && this.headerSlugs.includes(i.slug)) output.push(i.slug)
        })
        this.headerSlugs.forEach(i => {
          if (output.includes(i) && !sortedOutput.includes(i)) sortedOutput.push(i)
        })
        this.selectedFilters = sortedOutput
      } else {
        this.payrollFilter.forEach(i => {
          if(i.defaultShow) output.push(i.slug)
        })
        this.selectedFilters = output
      }
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    },
  },
  computed: {
    ...mapGetters([
      'organizationSettings'
    ]),
    headerSlugs () {
      return this.headers.map(h => h.payroll_filter)
    },
    filteredPayrollFilter() {
      return this.payrollFilter.filter(i => this.headerSlugs.includes(i.slug) || !this.headerSlugs.length)
    }
  },
  watch: {
    'selectedFilters': function(val) {
      this.$emit('change', val)
    }
  }
}
</script>